import { useEffect } from 'react';
import userSelectors from '../selectors';
import userActions from '../actions';
import { useAppDispatch } from 'store/hooks';

const useGetNotifications = () => {
  const dispatch = useAppDispatch();
  const notifications = userSelectors.notifications();

  const mutate = () => {
    dispatch(userActions.getNotifications.fetch());
  };

  useEffect(() => {
    mutate();
  }, []);

  return {
    notifications,
    mutate,
  };
};

export default useGetNotifications;
